/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import {NavLink} from "react-router-dom";
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

let ps;

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
    const classes = useStyles();
    const scrollSidebarFull = React.createRef();
    const scrollSidebarResponsive = React.createRef();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    // verifies if routeName is the one active (in browser input)
    function activeRoute(routeName) {
        return window.location.href.indexOf(routeName) > -1 ? true : false;
    }

    const {color, logo, image, logoText, routes} = props;
    const resizeFunction = () => {
        if (window.innerWidth >= 960) {
            setMobileOpen(false);
        }
    };

    function perfectScroll(scrollSidebar) {
        if (scrollSidebar.current) {
            return new PerfectScrollbar(scrollSidebar.current, {
                suppressScrollX: true,
                suppressScrollY: false
            });
        }
    }

    React.useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            ps = perfectScroll(scrollSidebarFull);
            document.body.style.overflow = "hidden";
        }
        window.addEventListener("resize", resizeFunction);
        // Specify how to clean up after this effect:
        return function cleanup() {
            if (navigator.platform.indexOf("Win") > -1) {
                if (scrollSidebarFull.current) ps.destroy();
            }
            window.removeEventListener("resize", resizeFunction);
        };
    }, [scrollSidebarFull]);

    React.useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            ps = perfectScroll(scrollSidebarResponsive);
            document.body.style.overflow = "hidden";
        }
        window.addEventListener("resize", resizeFunction);
        // Specify how to clean up after this effect:
        return function cleanup() {
            if (navigator.platform.indexOf("Win") > -1) {
                if (scrollSidebarResponsive.current) ps.destroy();
            }
            window.removeEventListener("resize", resizeFunction);
        };
    }, [scrollSidebarResponsive]);

    var links = (
        <List className={classes.list}>
            {routes.map((prop, key) => {
                var listItemClasses;
                listItemClasses = classNames({
                    [" " + classes[color]]: activeRoute(prop.path)
                });
                const whiteFontClasses = classNames({
                    [" " + classes.whiteFont]: activeRoute(prop.path)
                });
                return (
                    <NavLink
                        to={prop.path}
                        className={classes.item}
                        activeClassName="active"
                        key={key}
                    >
                        <ListItem button className={classes.itemLink + listItemClasses}>
                            {typeof prop.icon === "string" ? (
                                <Icon
                                    className={classNames(classes.itemIcon, whiteFontClasses)}
                                >
                                    {prop.icon}
                                </Icon>
                            ) : (
                                <prop.icon
                                    className={classNames(classes.itemIcon, whiteFontClasses)}
                                />
                            )}
                            <ListItemText
                                primary={props.rtlActive ? prop.rtlName : prop.name}
                                className={classNames(classes.itemText, whiteFontClasses)}
                                disableTypography={true}
                            />
                        </ListItem>
                    </NavLink>
                );
            })}
        </List>
    );
    var brand = (
        <div className={classes.logo}>
            <div className={classes.logoImage}>
                <NavLink to="/">
                    <img src={logo} alt="logo" className={classes.img}/>
                </NavLink>
            </div>
        </div>
    );

    return (
        <div>
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor="left"
                    open={props.open}
                    classes={{
                        paper: classNames(classes.drawerPaper)
                    }}
                    onClose={props.handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true // Better open performance on mobile.
                    }}
                >
                    {brand}
                    <div className={classes.sidebarWrapper} ref={scrollSidebarResponsive}>{links}</div>
                    {image !== undefined ? (
                        <div
                            className={classes.background}
                        />
                    ) : null}
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Drawer
                    anchor="left"
                    variant="permanent"
                    open
                    classes={{
                        paper: classNames(classes.drawerPaper)
                    }}
                >
                    {brand}
                    <div className={classes.sidebarWrapper} ref={scrollSidebarFull}>{links}</div>
                    {image !== undefined ? (
                        <div
                            className={classes.background}
                        />
                    ) : null}
                </Drawer>
            </Hidden>
        </div>
    );
}

Sidebar.propTypes = {
    rtlActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
    logo: PropTypes.string,
    image: PropTypes.string,
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    open: PropTypes.bool
};
